<template>
  <div>
    <van-cell-group title="付款信息" :border="true">
      <van-field v-model="child_payinfo.payer" label="付款单位" required size='large' placeholder="请选择付款单位" @click="payer_show = true" readonly is-link/>
      <van-action-sheet v-model="payer_show" :actions="payers" @select="payer_onselect" />
      <van-field v-model="child_payinfo.payment_term" readonly center label="付款方式" size='large' :border="true" placeholder="请选择付款方式" required :rules="[{ required: true, message: '请选择付款方式' }]"/>
      <!-- <van-action-sheet v-model="payment_term.show" :actions="payment_term.options" @select="payment_term_onselect" /> -->
      <van-checkbox-group v-model="child_payinfo.debit_ids" v-show="debits.show">
        <van-cell-group v-if="debits.data.length">
          <van-cell
            v-for="item in debits.data"
            clickable
            :key="item.id"
            :title="item.title"
            
          >
            <template #right-icon>
              <van-checkbox :name="item.id" ref="checkboxes" />
            </template>
            <template #label>
              待还金额：{{item.amount}}
            </template>
            <!-- <template #default>
              {{item.amount}}
            </template> -->
          </van-cell>
        </van-cell-group>
        <van-cell-group v-else>
          <van-empty description="暂无待还的借款" />
        </van-cell-group>
      </van-checkbox-group>
      <!-- <van-field readonly clickable label="付款方式" :value="payInfo.payment_term" placeholder="请选择付款方式" @click="payment_term.show = true"/>
      <van-popup v-model="payment_term.show" round position="bottom">
        <van-picker show-toolbar :columns="payment_term.options" @cancel="payment_term.show = false"   @confirm="payment_term_onselect" />
      </van-popup> -->
    </van-cell-group>

  </div>
</template>

<script>

export default {
  
  name: 'PayInfo',
  props: {
    // cost_centers:Array,
    payInfo:Object


  },
  data(){
    return{
      // payInfo:{
      //   payer:'',
      //   payee:'',
      //   bank:'',
      //   bank_account:'',
      //   payment_term:'',
      // },
      child_payinfo:this.payInfo,
      payment_term:{
        show:false,
        // options:['银行转账','现金','支票','承兑汇票'],
        options:[
          // {name:'银行转账'},
          // {name:'现金'},
        //   {name:'冲账'},
          {name:'冲借款'},
          ]
      },
      debits:{
        show:true,
        data:[],
      },
      payer_show:false,
      payers:[],

    }
  },
  created(){
    this.getPayers()
    this.getDebit();

  },
  methods:{
    getPayers(){
      this.$http.get('payer')
      .then((res)=>{
        this.payers = res.data.data
      })
    },
    // payment_term_onselect(item){
    //   this.payment_term.show = false
    //   this.child_payinfo.payment_term = item.name
    //   if(this.child_payinfo.payment_term == "冲借款"){
    //     this.debits.show = true;
    //   }else{
    //     this.debits.show = false;
    //   }
      
      
    // },
    payer_onselect(item){
      this.payer_show = false;
      this.child_payinfo.payer = item.name;
      this.child_payinfo.payer_id = item.id

    },
    getDebit(){
      this.$http.post('my_debit')
      .then((res)=>{
        console.log(res)
        if(res.data.code ==200){
          this.debits.data = res.data.data
        }

      })
    },
    // toggle(id){
    //   // console.log(this.child_payinfo)
    //   this.$emit('change_pay_info',this.child_payinfo)

    // }

  },
  watch:{
    'child_payinfo.payer':function(){
      console.log(this.child_payinfo)
      this.$emit('change_pay_info',this.child_payinfo)
    },
    // 'child_payinfo.payee':function(){
    //   this.$emit('change_pay_info',this.child_payinfo)
    // },
    // 'child_payinfo.bank':function(){
    //   this.$emit('change_pay_info',this.child_payinfo)
    // },
    // 'child_payinfo.bank_account':function(){
    //   this.$emit('change_pay_info',this.child_payinfo)
    // },
    // 'payInfo.amount':function(val){
    //   this.payInfo.amount_word = moneyToChinese(val);
    //   this.$emit('change_pay_info',this.payInfo)
    // },
    // 'child_payinfo.payment_term':function(){
    //   this.$emit('change_pay_info',this.child_payinfo)
    // },
    'child_payinfo.debit_ids':function(){
      this.$emit('change_pay_info',this.child_payinfo)
    },

  },
  // computed:{
  //   'payInfo.amount_word':function(){
  //     return moneyToChinese(this.payInfo.amount);

  //   }
  // }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.approvers{
  text-align: 0 auto;
  /* margin:10px; */
}
.approver{
  /* float:left; */
  display:inline;
  margin:10px 15px;

}

.approver .van-step{
  display:block;

}
h3 {
  font-size:12px;
  margin:5px;
}
p{
  margin:0px;
  font-size:12px;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.van-cell-group__title{
  background-color:#3f51b5 ;
  font-size:14px;
  font-weight:blod;
  color:white;
  padding:13px;

}
.van-cell__title span{
  float:left;
}
</style>
